import React from "react";

import { useTheme, useMediaQuery } from "@material-ui/core";

const withFullScreen =
  (Component, options = { breakpoint: "md" }) =>
  (props) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(
      theme.breakpoints.down(options.breakpoint)
    );
    return <Component fullScreen={fullScreen} {...props} />;
  };

export default withFullScreen;
